import { render, staticRenderFns } from "./table-sample.vue?vue&type=template&id=1861b2f2&scoped=true"
import script from "./table-sample.vue?vue&type=script&lang=js"
export * from "./table-sample.vue?vue&type=script&lang=js"
import style0 from "./table-sample.vue?vue&type=style&index=0&id=1861b2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1861b2f2",
  null
  
)

export default component.exports